import { render, staticRenderFns } from "./sjcj.vue?vue&type=template&id=9435f376&"
import script from "./sjcj.vue?vue&type=script&lang=ts&"
export * from "./sjcj.vue?vue&type=script&lang=ts&"
import style0 from "./sjcj.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports